import type { ReactNode } from 'react';

import { useLocation, useParams } from '@remix-run/react';
import type { TTagsElement } from '@shared/dream-components';
import { TagsElement } from '@shared/dream-components';

import TagsProvider from './TagsProvider';

interface Props {
  node: TTagsElement;
  children: ReactNode | ReactNode[];
}

const Tags = ({ node, children }: Props) => {
  const location = useLocation();
  const { tag } = useParams();

  const isTagPage = location.pathname === `/t/${tag}`;
  const isTagPageHeader = node?.attrs?.isTagPageHeader;
  const isPageHeader = isTagPage && isTagPageHeader;

  // isLive Makes the element clickable unless it's the current tag page,
  // in which case clicking would result in a redundant reload.
  const isLive = !isPageHeader;

  return (
    <TagsProvider>
      {/* biome-ignore lint/correctness/noUnusedVariables: Keep this for now */}
      {({ isLoading }) => {
        return (
          <TagsElement element={node} isLive={isLive}>
            {children}
          </TagsElement>
        );
      }}
    </TagsProvider>
  );
};

export default Tags;
